<template>
    <Breadcrumbs main="Blog" title="Blog Details" />
    <div class="container-fluid blog-page">
        <div class="row">
            <blogShadow />
            <blogList />
            <blogGrid />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const blogShadow = defineAsyncComponent(() => import("@/components/theme/blog/details/blogShadow.vue"))
const blogList = defineAsyncComponent(() => import("@/components/theme/blog/details/blogList.vue"))
const blogGrid = defineAsyncComponent(() => import("@/components/theme/blog/details/blogGrid.vue"))
</script>